import { PlusIcon } from "lucide-react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
// import { DoubleArrowDownIcon } from "@radix-ui/react-icons";

import { Button } from "@/components/ui/button/button";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs/tabs";
// import { Label } from "@/components/ui/label/label";
// import {
//   RadioGroup,
//   RadioGroupItem,
// } from "@/components/ui/radio-group/radio-group";

// import {
//   Popover,
//   PopoverContent,
//   PopoverTrigger,
// } from "@/components/ui/popover/popover";

// import { useStatusFilter } from "./hooks/use-status-filter";
import {
  getAllAllowanceRequestsOfEmployeeQueryOptions,
  getAllAllowanceRequestsOfOtherEmployeesAsApproverQueryOptions,
} from "@/config/queries/emp-query-options";
// import { Separator } from "@/components/ui/separator/separator";
import { Spinner } from "@/components/ui/spinner/spinner";
import { DataTable } from "./_components/allowance-requests-table/data-table";
import { columns } from "./_components/allowance-requests-table/columns";

import { DataTable as OthersDataTable } from "./_components/others-allowance-requests/others-allowance-requests-table/data-table";
import { columns as OthersColumns } from "./_components/others-allowance-requests/others-allowance-requests-table/columns";

import { useAuth } from "@/lib/use-auth";
import { ViewAllowanceModal } from "./_components/others-allowance-requests/view-allowance-modal/view-allowance-modal";
import { CancelAllowanceRequestModal } from "./_components/cancel-leave-request-modal/cancel-request-modal";

const AllowancePageForEmployee = () => {
  const { data: authData } = useAuth();
  // const [tabValue, setTabValue] = useState("my-allowance-requests");

  const employeeKey = Cookies.get("key") as string;
  // const { filter, setFilter } = useStatusFilter();

  const {
    data: allOtherAllowanceData,
    isPending: isOtherAllowancePending,
    isFetching: isOtherAllowanceFetching,
  } = useQuery(
    getAllAllowanceRequestsOfOtherEmployeesAsApproverQueryOptions(
      employeeKey,
      authData?.user?.permissions?.["1"]?.includes("Allowance")
      // filter
    )
  );

  const othersAllowances = useMemo(() => {
    if (isOtherAllowancePending) {
      return [];
    }

    if (
      allOtherAllowanceData === undefined ||
      allOtherAllowanceData?.allowances === undefined
    ) {
      return [];
    }

    const result = allOtherAllowanceData?.allowances?.map((la) => {
      return {
        id: la?._id,
        reason: la?.reason,
        amountRequested: la?.amountRequested,
        status: la?.status,
        employeeName: la?.employee?.name,
        employeeEmail: la?.employee?.email,
        createdAt: la?.createdAt,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
    );
  }, [
    allOtherAllowanceData,
    isOtherAllowanceFetching,
    isOtherAllowancePending,
  ]);

  const { data, isPending, isFetching } = useQuery(
    getAllAllowanceRequestsOfEmployeeQueryOptions(employeeKey)
  );

  const allowancesData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.Allowances === undefined) {
      return [];
    }

    const result = data?.Allowances?.map((la) => {
      return {
        id: la?._id,
        reason: la?.reason,
        amountRequested: la?.amountRequested,
        status: la?.status,
        employeeName: la?.employee?.name,
        employeeEmail: la?.employee?.email,
        createdAt: la?.createdAt,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
    );
  }, [isPending, isFetching, data]);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Allowance</h3>

        <div className="flex flex-row items-center gap-3">
          <Button className="flex items-center gap-1" asChild>
            <Link to="/employee/allowance/new">
              <PlusIcon />
              <span>Create Allowance</span>
            </Link>
          </Button>
        </div>
      </div>

      <div className="mt-3">
        <Tabs defaultValue="my-allowance-requests" className="w-full">
          <div className="flex items-center justify-between">
            <TabsList>
              <TabsTrigger
                value="my-allowance-requests"
                // onClick={() => setTabValue("my-allowance-requests")}
              >
                My Allowance Requests
              </TabsTrigger>
              {authData?.user?.permissions?.["1"]?.includes("Allowance") && (
                <TabsTrigger
                  value="other-allowance-requests"
                  // onClick={() => setTabValue("other-allowance-requests")}
                >
                  Other's Allowance Requests
                </TabsTrigger>
              )}
            </TabsList>

            {/* {tabValue === "other-allowance-requests" && (
              <>
                <Popover>
                  <PopoverTrigger>
                    <Button
                      className="flex items-center gap-2"
                      size="sm"
                      variant="outline"
                    >
                      <DoubleArrowDownIcon className="w-4 h-4" />
                      Filter
                      {filter && (
                        <>
                          <Separator orientation="vertical" />
                          {filter}
                        </>
                      )}
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent>
                    <RadioGroup
                      value={filter}
                      onValueChange={(
                        value: "Pending" | "Approved" | "Rejected"
                      ) => {
                        setFilter(value);
                      }}
                    >
                      <div className="flex items-center space-x-2 cursor-pointer w-fit">
                        <RadioGroupItem value="Pending" id="pending" />
                        <Label htmlFor="pending">Pending</Label>
                      </div>
                      <div className="flex items-center space-x-2 cursor-pointer w-fit">
                        <RadioGroupItem value="Approved" id="approved" />
                        <Label htmlFor="approved">Approved</Label>
                      </div>
                      <div className="flex items-center space-x-2 cursor-pointer w-fit">
                        <RadioGroupItem value="Rejected" id="rejected" />
                        <Label htmlFor="rejected">Rejected</Label>
                      </div>
                    </RadioGroup>
                  </PopoverContent>
                </Popover>
              </>
            )} */}
          </div>
          <TabsContent value="my-allowance-requests">
            {isPending ? (
              <div className="h-20 mt-10 flex items-center justify-center">
                <Spinner size="small">
                  <p>Searching for Leave Applications...</p>
                </Spinner>
              </div>
            ) : data?.Allowances?.length ? (
              <div className="mt-5">
                <DataTable data={allowancesData} columns={columns} />
              </div>
            ) : (
              <div className="border h-20 flex items-center justify-center mt-5">
                No Allowances
              </div>
            )}
          </TabsContent>
          {authData?.user?.permissions?.["1"]?.includes("Allowance") && (
            <TabsContent value="other-allowance-requests">
              {isOtherAllowancePending ? (
                <div className="h-20 mt-10 flex items-center justify-center">
                  <Spinner size="small">
                    <p>Searching for Allowance Requests of others...</p>
                  </Spinner>
                </div>
              ) : allOtherAllowanceData?.allowances?.length ? (
                <div className="mt-5">
                  <OthersDataTable
                    data={othersAllowances}
                    columns={OthersColumns}
                  />
                </div>
              ) : (
                <div className="border h-20 flex items-center justify-center mt-5">
                  No Allowance Requests of others.
                </div>
              )}
            </TabsContent>
          )}
        </Tabs>
      </div>

      <ViewAllowanceModal />

      <CancelAllowanceRequestModal />
    </div>
  );
};

export default AllowancePageForEmployee;
